import MuiAddIcon from "@material-ui/icons/Add";

const AddIcon = MuiAddIcon;

export default AddIcon;